import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { usePageVisible } from '@/hooks/usePageVisible';
import { useUserRole } from '@/hooks/useUserRole';

export interface AuthLog {
  id: string;
  timestamp: number;
  event_message: string;
  level: string;
  status: number;
  path: string;
  msg: string;
  error: string;
}

export function useAuthLogs() {
  const { isAdmin } = useUserRole();
  const visible = usePageVisible();

  return useQuery({
    queryKey: ['auth-logs'],
    enabled: isAdmin,
    refetchInterval: isAdmin && visible ? 60_000 : false,
    queryFn: async () => {
      const query = `
        SELECT id, auth_logs.timestamp, event_message, metadata.level, metadata.status, metadata.path, metadata.msg as msg, metadata.error
        FROM auth_logs
        CROSS JOIN UNNEST(metadata) AS metadata
        ORDER BY timestamp DESC
        LIMIT 100
      `;

      const { data, error } = await supabase.rpc('supabase--analytics-query' as any, {
        query,
      }) as any;

      if (error) throw error;
      return data || [];
    },
  });
}
